import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  open: false,
  promptId: null,
  promptData: {},
  isSavePromptModalOpen: false,
  currentPromptRow: [],
  refreshPrompts: false,
};

const ModalSlice = createSlice({
  name: "Modal",
  initialState,
  reducers: {
    currentPromptRow: (state, action) => {
      state.currentPromptRow = action.payload;
    },
    openPromptModal: (state, action) => {
      state.open = true;
      state.promptId = action.payload.promptId;
      state.promptData = action.payload.promptData;
    },
    closePromptModal: (state) => {
      state.open = false;
      state.promptId = null;
      state.promptData = {};
      state.currentPromptRow = [];
    },
    openSavePromptModal: (state) => {
      state.isSavePromptModalOpen = true;
    },
    closeSavePromptModal: (state) => {
      state.isSavePromptModalOpen = false;
    },
    setRefreshPrompts: (state, action) => {
      state.refreshPrompts = action.payload;
    },
  },
});

export const { 
  openPromptModal, 
  closePromptModal, 
  openSavePromptModal, 
  closeSavePromptModal, 
  currentPromptRow,
  setRefreshPrompts
} = ModalSlice.actions;

export default ModalSlice.reducer;
